import { render, staticRenderFns } from "./context-menu.vue?vue&type=template&id=f56b4bfe"
import script from "./context-menu.vue?vue&type=script&lang=js"
export * from "./context-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f56b4bfe')) {
      api.createRecord('f56b4bfe', component.options)
    } else {
      api.reload('f56b4bfe', component.options)
    }
    module.hot.accept("./context-menu.vue?vue&type=template&id=f56b4bfe", function () {
      api.rerender('f56b4bfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/context-menu.vue"
export default component.exports